import React, { useState } from 'react';
import { MailIcon, ArrowLeftIcon, MapIcon, CalendarIcon, PresentationIcon, ChevronRightIcon, ShieldCheckIcon, FileTextIcon, ClipboardListIcon, ArrowRightIcon, PlayCircleIcon, XIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
export function InvestorDeckPage() {
  const [videoOpen, setVideoOpen] = useState(false);
  return <div className="min-h-screen bg-gray-50 font-sans text-[#111111]" data-id="element-1635">
      {/* Private Header */}
      <header className="bg-white border-b border-gray-200 sticky top-0 z-50" data-id="element-1636">
        <div className="max-w-7xl mx-auto px-4 md:px-6 h-14 md:h-16 flex items-center justify-between" data-id="element-1637">
          <div className="flex items-center space-x-2 md:space-x-4 min-w-0" data-id="element-1638">
            <Link to="/" className="text-gray-500 hover:text-[#631bb7] transition-colors shrink-0" data-id="element-1639">
              <ArrowLeftIcon size={18} data-id="element-1640" />
            </Link>
            <div className="h-5 w-px bg-gray-200 shrink-0" data-id="element-1641"></div>
            <img src="https://cdn.magicpatterns.com/uploads/u2RsmpFkExbV8oAVAJrtqh/Caveo-Lockup-FC.png" alt="Caveo" className="h-5 md:h-6 shrink-0" data-id="element-1642" />
            <span className="bg-gray-100 text-gray-600 text-[10px] md:text-xs font-semibold px-1.5 md:px-2 py-0.5 md:py-1 rounded-full uppercase tracking-wide shrink-0 hidden sm:inline-block" data-id="element-1643">
              Investor Portal
            </span>
          </div>
          <div className="text-xs md:text-sm text-gray-500 shrink-0" data-id="element-1644">
            Confidential
          </div>
        </div>
      </header>

      <main className="max-w-5xl mx-auto px-4 md:px-6 py-6 md:py-8 space-y-6 md:space-y-8" data-id="element-1645">
        {/* Welcome / Hero */}
        <section className="text-center max-w-3xl mx-auto" data-id="element-1646">
          <h1 className="text-2xl md:text-4xl font-bold mb-2 md:mb-3 text-[#111111]" data-id="element-1647">
            Welcome to the Caveo Investor Portal
          </h1>
          <p className="text-base md:text-lg text-gray-600 leading-relaxed" data-id="element-1648">
            Access our strategic overview and product roadmap as we redefine
            family digital safety.
          </p>
        </section>

        {/* Review — 3 visual cards */}
        <section className="max-w-4xl mx-auto" data-id="element-1649">
          <p className="text-[10px] md:text-xs font-medium text-gray-400 uppercase tracking-wider mb-2 md:mb-3" data-id="element-1650">
            Review
          </p>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-3 md:gap-4" data-id="element-1651">
            {/* Product Overview Card */}
            <Link to="/investor-overview" className="group bg-white rounded-xl border border-gray-200 shadow-sm hover:shadow-lg hover:border-[#631bb7] transition-all no-underline overflow-hidden flex flex-col" data-id="element-1652">
              <div className="p-4 pb-2" data-id="element-1653">
                <p className="text-[10px] font-semibold text-[#631bb7] uppercase tracking-wider mb-1.5" data-id="element-1654">
                  Product Overview
                </p>
                <h2 className="text-sm md:text-base font-bold text-[#111111] leading-snug mb-1" data-id="element-1655">
                  Our platform, philosophy, and how we serve families
                </h2>
                <p className="text-[11px] text-gray-400" data-id="element-1656">Read more →</p>
              </div>
              <div className="mt-auto px-3 pb-3" data-id="element-1657">
                <div className="rounded-lg overflow-hidden border border-gray-100 bg-gray-50 max-h-[120px]" data-id="element-1658">
                  <img src="https://cdn.magicpatterns.com/uploads/woHzphed13KEKqew84CfjV/Solution_Overview.png" alt="Product Overview preview" className="w-full h-full object-cover object-top group-hover:scale-[1.02] transition-transform duration-300" data-id="element-1659" />
                </div>
              </div>
            </Link>

            {/* Current Roadmap Card */}
            <Link to="/investor-roadmap" className="group bg-white rounded-xl border border-gray-200 shadow-sm hover:shadow-lg hover:border-[#631bb7] transition-all no-underline overflow-hidden flex flex-col" data-id="element-1660">
              <div className="p-4 pb-2" data-id="element-1661">
                <p className="text-[10px] font-semibold text-[#631bb7] uppercase tracking-wider mb-1.5" data-id="element-1662">
                  Current Roadmap
                </p>
                <h2 className="text-sm md:text-base font-bold text-[#111111] leading-snug mb-1" data-id="element-1663">
                  Product strategy, features, and development timeline
                </h2>
                <p className="text-[11px] text-gray-400" data-id="element-1664">Read more →</p>
              </div>
              <div className="mt-auto px-3 pb-3" data-id="element-1665">
                <div className="rounded-lg overflow-hidden border border-gray-100 bg-gray-50 max-h-[120px]" data-id="element-1666">
                  <img src="https://cdn.magicpatterns.com/uploads/8EJKjEme9egwK3ZfSJtvVA/ProductRoadmap.png" alt="Current Roadmap preview" className="w-full h-full object-cover object-top group-hover:scale-[1.02] transition-transform duration-300" data-id="element-1667" />
                </div>
              </div>
            </Link>

            {/* Video Overview Card */}
            <button onClick={() => setVideoOpen(true)} className="group bg-white rounded-xl border border-gray-200 shadow-sm hover:shadow-lg hover:border-[#631bb7] transition-all overflow-hidden flex flex-col text-left cursor-pointer w-full" data-id="element-1668">
              <div className="p-4 pb-2" data-id="element-1669">
                <p className="text-[10px] font-semibold text-[#631bb7] uppercase tracking-wider mb-1.5" data-id="element-1670">
                  Video Overview
                </p>
                <h2 className="text-sm md:text-base font-bold text-[#111111] leading-snug mb-1" data-id="element-1671">
                  Watch our 2-minute animated introduction
                </h2>
                <p className="text-[11px] text-gray-400" data-id="element-1672">Watch now →</p>
              </div>
              <div className="mt-auto px-3 pb-3" data-id="element-1673">
                <div className="rounded-lg overflow-hidden border border-gray-100 bg-gray-50 relative max-h-[120px]" data-id="element-1674">
                  <img src="https://cdn.magicpatterns.com/uploads/aNcNtFu8MWQjU5vT6wCcrH/video_image.png" alt="Video Overview preview" className="w-full h-full object-cover object-top group-hover:scale-[1.02] transition-transform duration-300" data-id="element-1675" />
                  <div className="absolute inset-0 flex items-center justify-center" data-id="element-1676">
                    <div className="w-9 h-9 bg-white/90 rounded-full flex items-center justify-center shadow-lg group-hover:scale-110 transition-transform" data-id="element-1677">
                      <PlayCircleIcon size={20} className="text-[#631bb7]" data-id="element-1678" />
                    </div>
                  </div>
                </div>
              </div>
            </button>
          </div>
        </section>

        {/* Contact / Due Diligence */}
        <section className="bg-white rounded-xl p-5 md:p-8 border border-gray-200 text-center max-w-4xl mx-auto" data-id="element-1679">
          <h2 className="text-lg md:text-xl font-bold mb-2 md:mb-3" data-id="element-1680">
            Questions or Due Diligence Requests?
          </h2>
          <p className="text-xs md:text-sm text-gray-600 mb-4 md:mb-5 max-w-2xl mx-auto" data-id="element-1681">
            We're happy to provide additional data room access or schedule a
            deep dive into our product roadmap and go-to-market strategy.
          </p>
          <div className="flex flex-col sm:flex-row justify-center gap-2 md:gap-3" data-id="element-1682">
            <a href="mailto:jbp@caveohq.com" className="inline-flex items-center justify-center bg-[#631bb7] text-white px-4 md:px-5 py-2.5 rounded-lg font-semibold hover:bg-[#521099] transition-colors text-sm" data-id="element-1683">
              <MailIcon size={15} className="mr-2" data-id="element-1684" />
              Email Us
            </a>
            <a href="https://calendar.app.google/EnoqEH7z4cY89jjN8" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center bg-[#631bb7] text-white px-4 md:px-5 py-2.5 rounded-lg font-semibold hover:bg-[#521099] transition-colors text-sm" data-id="element-1685">
              <CalendarIcon size={15} className="mr-2" data-id="element-1686" />
              Book a Meeting
            </a>
          </div>
        </section>

        {/* Ready to Invest? */}
        <section className="max-w-4xl mx-auto" data-id="element-1687">
          <div className="bg-white rounded-xl border border-gray-200 shadow-sm p-5 md:p-8" data-id="element-1688">
            <div className="text-center mb-4 md:mb-5" data-id="element-1689">
              <h2 className="text-xl md:text-2xl font-bold text-[#111111] mb-1" data-id="element-1690">
                Ready to Invest?
              </h2>
              <p className="text-xs md:text-sm text-gray-500 max-w-xl mx-auto" data-id="element-1691">
                Here's what to expect when you proceed:
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-3 md:gap-4 mb-5" data-id="element-1692">
              <div className="flex items-start gap-2.5 bg-gray-50 rounded-lg p-3" data-id="element-1693">
                <div className="w-7 h-7 bg-[#f0ebf8] rounded-md flex items-center justify-center shrink-0 mt-0.5" data-id="element-1694">
                  <ShieldCheckIcon size={14} className="text-[#631bb7]" data-id="element-1695" />
                </div>
                <div data-id="element-1696">
                  <p className="font-semibold text-xs text-[#111111] mb-0.5" data-id="element-1697">
                    Review Disclosures
                  </p>
                  <p className="text-[11px] text-gray-500 leading-tight" data-id="element-1698">
                    Legal disclosures and accredited investor requirements.
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-2.5 bg-gray-50 rounded-lg p-3" data-id="element-1699">
                <div className="w-7 h-7 bg-[#f0ebf8] rounded-md flex items-center justify-center shrink-0 mt-0.5" data-id="element-1700">
                  <FileTextIcon size={14} className="text-[#631bb7]" data-id="element-1701" />
                </div>
                <div data-id="element-1702">
                  <p className="font-semibold text-xs text-[#111111] mb-0.5" data-id="element-1703">
                    Review SAFE Agreement
                  </p>
                  <p className="text-[11px] text-gray-500 leading-tight" data-id="element-1704">
                    Terms of the SAFE investment agreement.
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-2.5 bg-gray-50 rounded-lg p-3" data-id="element-1705">
                <div className="w-7 h-7 bg-[#f0ebf8] rounded-md flex items-center justify-center shrink-0 mt-0.5" data-id="element-1706">
                  <ClipboardListIcon size={14} className="text-[#631bb7]" data-id="element-1707" />
                </div>
                <div data-id="element-1708">
                  <p className="font-semibold text-xs text-[#111111] mb-0.5" data-id="element-1709">
                    Submit Interest Form
                  </p>
                  <p className="text-[11px] text-gray-500 leading-tight" data-id="element-1710">
                    We'll send you a contract to sign.
                  </p>
                </div>
              </div>
            </div>

            <div className="text-center" data-id="element-1711">
              <Link to="/invest" className="inline-flex items-center justify-center bg-[#631bb7] text-white px-6 py-3 rounded-lg font-bold hover:bg-[#521099] transition-colors text-sm md:text-base shadow-md no-underline" data-id="element-1712">
                Invest Now
                <ArrowRightIcon size={18} className="ml-2" data-id="element-1713" />
              </Link>
            </div>
          </div>
        </section>

        {/* Pitch Deck */}
        <section className="bg-white rounded-xl border border-gray-200 shadow-sm overflow-hidden max-w-4xl mx-auto" data-id="element-1714">
          <div className="flex items-center gap-3 px-5 py-3 border-b border-gray-100 bg-gray-50" data-id="element-1715">
            <PresentationIcon size={18} className="text-[#631bb7]" data-id="element-1716" />
            <h2 className="text-base font-bold text-[#111111]" data-id="element-1717">Pitch Deck</h2>
          </div>
          <div className="w-full" style={{
          aspectRatio: '16/9'
        }} data-id="element-1718">
            <iframe src="https://docs.google.com/presentation/d/1fVC6uDiXaNJSw2id2Ss5M1aR9t8FIXEyFTrRizzsmzk/embed?start=false&loop=false&delayms=3000" className="w-full h-full border-0" allowFullScreen title="Caveo Pitch Deck" data-id="element-1719" />
          </div>
        </section>

        {/* Trust / Logo Strip */}
        <section className="max-w-4xl mx-auto" data-id="element-1720">
          <p className="text-center text-xs md:text-sm font-medium text-gray-400 uppercase tracking-wider mb-4 md:mb-6" data-id="element-1721">
            Built by leaders from
          </p>
          <div className="flex flex-wrap items-center justify-center gap-x-8 md:gap-x-12 gap-y-4 grayscale opacity-50" data-id="element-1722">
            <img src="https://cdn.magicpatterns.com/uploads/nmqUJqLxx2VskE1njSdPet/Experian_logo.svg.png" alt="Experian" className="h-6 md:h-8 max-w-[100px] md:max-w-[120px] object-contain" data-id="element-1723" />
            <img src="https://cdn.magicpatterns.com/uploads/fnXGBwy5K7uyX2UvFt6ups/Asana_logo.svg.png" alt="Asana" className="h-5 md:h-7 max-w-[80px] md:max-w-[100px] object-contain" data-id="element-1724" />
            <img src="https://cdn.magicpatterns.com/uploads/jTvJx4FmjnAA5ZM439Lq8G/drift-logo-png_seeklogo-394571.png" alt="Drift" className="h-5 md:h-7 max-w-[70px] md:max-w-[90px] object-contain" data-id="element-1725" />
            <img src="https://cdn.magicpatterns.com/uploads/vjVVFtuWSA5UFtZmC7CMpG/Intel-Logo.png" alt="Intel" className="h-6 md:h-8 max-w-[60px] md:max-w-[70px] object-contain" data-id="element-1726" />
            <img src="https://cdn.magicpatterns.com/uploads/gifY524awm2QkgRHAkporM/NBCUniversal_2026_Logo.svg" alt="NBCUniversal" className="h-5 md:h-7 max-w-[110px] md:max-w-[140px] object-contain" data-id="element-1727" />
          </div>
        </section>
      </main>

      <footer className="bg-white border-t border-gray-200 py-6 md:py-8 mt-auto" data-id="element-1728">
        <div className="max-w-7xl mx-auto px-4 md:px-6 text-center text-xs md:text-sm text-gray-500" data-id="element-1729">
          <p data-id="element-1730">&copy; 2026 AppEmbrace, Inc. DBA Caveo. All rights reserved.</p>
          <p className="mt-1 md:mt-2 text-xs text-gray-400" data-id="element-1731">
            This page contains confidential information intended only for
            authorized investors. Do not share or distribute without permission.
          </p>
        </div>
      </footer>

      {/* Video Modal */}
      {videoOpen && <div className="fixed inset-0 bg-black/70 z-[9999] flex items-center justify-center p-4" onClick={() => setVideoOpen(false)} data-id="element-1732">
          <div className="relative w-full max-w-4xl bg-black rounded-2xl overflow-hidden" onClick={e => e.stopPropagation()} data-id="element-1733">
            <button onClick={() => setVideoOpen(false)} className="absolute top-3 right-3 z-10 w-9 h-9 bg-white/10 hover:bg-white/20 rounded-full flex items-center justify-center transition-colors border-0 cursor-pointer" data-id="element-1734">
              <XIcon size={18} className="text-white" data-id="element-1735" />
            </button>
            <div className="w-full relative" style={{
          paddingBottom: '56.25%',
          height: 0
        }} data-id="element-1736">
              <iframe src="https://jumpshare.com/embed/o8NBYlbymwfkAKtfpp3E" frameBorder="0" allowFullScreen className="absolute top-0 left-0 w-full h-full" title="Caveo Overview Video" data-id="element-1737" />
            </div>
          </div>
        </div>}
    </div>;
}